// import storage from 'storejs';
// import serviceAPI from '../../api/serviceAPI';
import serviceApi from '../../api/userAPI';

export default {
  namespaced: true,
  state: {
    allAreas: [], // 专区下拉
    mallDetails: {}, // 商品详情
    rows: [], // 记忆选择
  },
  getters: {
    mallDetails(state) {
      return state.mallDetails;
    },
    getRows: state => state.rows,
    allAreas: state => state.allAreas,
  },
  mutations: {
    // 设置登录信息
    setMallDetails(state, mallDetails) {
      console.log('mallDetails', mallDetails);
      state.mallDetails = {};
      state.mallDetails.code = mallDetails.code;
      state.mallDetails.goodsDesc = mallDetails.goodsDesc;
      state.mallDetails.goodsName = mallDetails.goodsName;
      state.mallDetails.integralPrice = mallDetails.integralPrice;
      state.mallDetails.thumbnailUrl = mallDetails.thumbnailUrl;
      state.mallDetails.saleCount = mallDetails.saleCount;
    },
    insertRow: (state, row) => {
      const index = state.rows.findIndex(item => {
        return item.lecturerCode === row.lecturerCode;
      });
      if (index === -1) {
        state.rows.push(row);
      }
    },
    deleteRow: (state, { lecturerCode }) => {
      const index = state.rows.findIndex(item => {
        return item.lecturerCode === lecturerCode;
      });
      if (index !== -1) {
        state.rows.splice(index, 1);
      }
    },
    insertAllRow: (state, rows) => {
      rows.forEach(item => {
        const index = state.rows.findIndex(ele => {
          return ele.lecturerCode === item.lecturerCode;
        });
        if (index === -1) {
          state.rows.push(item);
        }
      });
    },
    deleteAllRow: (state, rows) => {
      rows.forEach(item => {
        const index = state.rows.findIndex(ele => {
          return ele.lecturerCode === item.lecturerCode;
        });
        if (index !== -1) {
          state.rows.splice(index, 1);
        }
      });
    },
    setRows: (state, rows) => {
      state.rows = JSON.parse(JSON.stringify(rows));
    },
    setAllAreas: (state, allAreas) => {
      state.allAreas = JSON.parse(JSON.stringify(allAreas));
    },
  },
  actions: {
    // 保存用户信息
    saveMallDetail({ commit }, mallDetails) {
      console.log('父类调用');
      //  读取storage保存商品详情
      const currentMallDetails = {};
      currentMallDetails.code = mallDetails.code;
      currentMallDetails.goodsDesc = mallDetails.goodsDesc;
      currentMallDetails.goodsName = mallDetails.goodsName;
      currentMallDetails.integralPrice = mallDetails.integralPrice;
      currentMallDetails.thumbnailUrl = mallDetails.thumbnailUrl;
      currentMallDetails.saleCount = mallDetails.saleCount;
      // storage({ 'mallDetails': currentMallDetails });
      commit('setMallDetails', mallDetails);
    },

    // 获取所属专区下拉列表
    async getAllAreas({ commit }, params) {
      try {
        const areaList = await serviceApi.getStructureList(params);
        commit('setAllAreas', areaList.data);
      } catch (error) {
        // 抛出异常
        throw error;
      }
    },

    // 获取商品详情
    /**
     * @param {Object} params-请求参数
     * @param {String} params.code-code
     */
    // async getMallDetails({ dispatch }, params) {
    //   try {
    //     const mallDetails = await serviceAPI.getMallDetails(params);
    //     // 保存商品信息
    //     dispatch('saveMallDetail', mallDetails.data);
    //     // return mallDetail;
    //   } catch (error) {
    //     // 抛出异常
    //     throw error;
    //   }
    // },

    // 获取站内信消息
    /**
     * @param {Object} params-请求参数
     */
    // async getNewMsg(context, params) {
    //   try {
    //     // 查询用户状态信息
    //     return await serviceAPI.getNewMsg(params);
    //   } catch (error) {
    //     // 抛出异常
    //     throw error;
    //   }
    // },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/content.js